import { useEffect, useMemo, useRef } from 'react';

import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { fetchAllProjectCategoriesForChannel } from '@/store/slices/categories';
import { getActiveChannel } from '@/store/slices/user/selectors';
import { selectAllProjectCategoriesForChannel } from '@/store/slices/categories/selectors';

type TUseLoadChannelProjectCategories = {
  skipIfCategoriesExist?: boolean;
  templatesOnly?: boolean;
};

const useLoadChannelProjectCategories = (props?: TUseLoadChannelProjectCategories) => {
  const { skipIfCategoriesExist, templatesOnly } = props || {};

  const channel = useAppSelector(getActiveChannel);
  const categories = useAppSelector(selectAllProjectCategoriesForChannel);

  const dispatch = useAppDispatch();

  const fetched = useRef(false);

  const shouldReturnEarly = useMemo(() => {
    return skipIfCategoriesExist && categories;
  }, [skipIfCategoriesExist, categories]);

  useEffect(() => {
    if (!channel || fetched.current || shouldReturnEarly) {
      return;
    }
    fetched.current = true;
    dispatch(
      fetchAllProjectCategoriesForChannel({
        channel,
        returnStoreStateIfExists: true,
        templatesOnly,
      })
    );
  }, [channel, dispatch, shouldReturnEarly, templatesOnly]);
};

export default useLoadChannelProjectCategories;
